module.exports = __webpack_public_path__ + "img/11.e283f620.png";